module.exports = __webpack_public_path__ + "img/zaun.3698449b.jpg";